import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import bgimage from "./img/Background_Sidebar.jpg"

import { Profile, SidebarNav, MiniSidebar } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {

    [theme.breakpoints.up('lg')]: {
      // marginTop: 64,
      // height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundImage: "url(" + bgimage + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    height: '200%',
    display: 'flex',
    flexDirection: 'column',
    width: "250px"
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  bgClass: {
    height: '200%',
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  noRoot: {
    height: '200%',
    display: 'flex',
    flexDirection: 'column',

  }

}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const classes = useStyles();



  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}

        className={sidebarOpen ? clsx(classes.root, className) : clsx(classes.noRoot, className)}
        onMouseEnter={() => setSidebarOpen(true)} onMouseLeave={() => setSidebarOpen(false)}>
        <div
          className={classes.bgClass}>


          <Profile />
          <Divider className={classes.divider} />
          {
            sidebarOpen ? <SidebarNav />
              : <MiniSidebar />
          }
          {/* <SidebarNav /> */}
        </div>
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
